document.addEventListener("DOMContentLoaded", function () {

  const sortSelect = document.getElementById("SortBy");
  const clearFiltersBtn = document.getElementById("ClearFilters");
  const mobileToggle = document.getElementById("MobileFilterToggle");
  const sidebar = document.getElementById("CollectionSidebar");
  const activeFiltersContainer = document.getElementById("ActiveFilters");
  const productsGrid = document.querySelector(".products-grid");
  const productCards = Array.from(document.querySelectorAll(".product-card"));
  const productCountEl = document.getElementById("ProductCount");
  const productCountLabel = document.getElementById("ProductCountLabel");
  const paginationEl = document.querySelector(".pagination");

  // Mobile Apply / Cancel buttons
  const mobileApplyBtn = document.getElementById("MobileApplyFilters");
  const mobileCancelBtn = document.getElementById("MobileCancelFilters");

  // Badge elements
  const ulCertDefault = document.getElementById("ul-cert-default");
  const ulCertEscooter = document.getElementById("ul-cert-escooter");
  const warrantyBadge = document.getElementById("warranty-badge");

  const MOBILE_BREAKPOINT = 768;
  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  let activeFilters = {
    colors: [],
    sizes: [],
    types: [],
    vendors: [],
    materials: [],
    availability: false,
    priceRangeLabel: null,
    brands: [],
    styles: [],
    range: [],
    speed: [],
    capacity: [],
    weight: [],
    power: [],
    frametypes: [],
    priceMin: null,
    priceMax: null,
    producttypes: [],
  };

  // Snapshot of the last APPLIED filter state on mobile. Used to restore
  // everything (checkboxes + activeFilters) if the user hits Cancel.
  let filtersSnapshot = null;

  function snapshotFilters() {
    return JSON.parse(JSON.stringify(activeFilters));
  }

  // Re-check/un-check every filter input so the UI matches a given filter state.
  function syncCheckboxesToFilters(filters) {
    document
      .querySelectorAll('input[type="checkbox"][data-filter]')
      .forEach((checkbox) => {
        const key = checkbox.dataset.filter;

        if (checkbox.dataset.min) {
          const list = filters[key] || [];
          checkbox.checked = list.some(
            (r) => String(r.min) === String(checkbox.dataset.min)
          );
        } else {
          const filterKey = key + "s";
          const list = filters[filterKey] || [];
          checkbox.checked = list.includes(checkbox.value);
        }
      });

    document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      checkbox.checked =
        filters.priceMin !== null && filters.priceMin === min;
    });
  }

  function updateBadgeVisibility() {
    // Check if escooter is in the active product types
    const isEscooterSelected = activeFilters.producttypes?.some(
      (type) => type.toLowerCase() === 'escooter'
    );

    // Check if gotrax brand is selected (gotrax only sells escooters)
    const isGotraxSelected = activeFilters.brands?.some(
      (brand) => brand.toLowerCase() === 'gotrax'
    );

    // Show escooter badges if either escooter product type OR gotrax brand is selected
    if (isEscooterSelected || isGotraxSelected) {
      // Show escooter certification, hide default
      if (ulCertDefault) ulCertDefault.style.display = "none";
      if (ulCertEscooter) ulCertEscooter.style.display = "inline";
      
      // Hide warranty badge for escooters
      if (warrantyBadge) warrantyBadge.style.display = "none";
    } else {
      // Show default certification, hide escooter
      if (ulCertDefault) ulCertDefault.style.display = "inline";
      if (ulCertEscooter) ulCertEscooter.style.display = "none";
      
      // Show warranty badge for non-escooters
      if (warrantyBadge) warrantyBadge.style.display = "flex";
    }
  }

  function matchesRange(value, ranges) {
    if (!ranges.length) return true;
    return ranges.some((r) => value >= r.min && value <= r.max);
  }

  function countProductsForFilter(
    filterType,
    filterValue,
    isRange = false,
    rangeMin = null,
    rangeMax = null
  ) {
    let count = 0;

    productCards.forEach((card) => {
      let tempShow = true;

      if (activeFilters.colors.length && filterType !== "color") {
        if (
          !activeFilters.colors.some((c) =>
            card.dataset.productColors?.split(",").includes(c)
          )
        ) {
          tempShow = false;
        }
      }

      if (activeFilters.sizes.length && filterType !== "size") {
        if (
          !activeFilters.sizes.some((s) =>
            card.dataset.productSizes?.split(",").includes(s)
          )
        ) {
          tempShow = false;
        }
      }

      if (activeFilters.producttypes?.length && filterType !== "producttype") {
        if (!activeFilters.producttypes.includes(card.dataset.producttype)) {
          tempShow = false;
        }
      }

      if (activeFilters.brands?.length && filterType !== "brand") {
        if (!activeFilters.brands.includes(card.dataset.brand)) {
          tempShow = false;
        }
      }

      if (activeFilters.styles?.length && filterType !== "style") {
        const productStyles =
          card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
          [];
        if (!activeFilters.styles.some((s) => productStyles.includes(s))) {
          tempShow = false;
        }
      }

      if (activeFilters.frametypes?.length && filterType !== "frametype") {
        if (!activeFilters.frametypes.includes(card.dataset.frametype)) {
          tempShow = false;
        }
      }

      if (
        filterType !== "range" &&
        !matchesRange(+card.dataset.range, activeFilters.range || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "speed" &&
        !matchesRange(+card.dataset.speed, activeFilters.speed || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "capacity" &&
        !matchesRange(+card.dataset.capacity, activeFilters.capacity || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "weight" &&
        !matchesRange(+card.dataset.weight, activeFilters.weight || [])
      ) {
        tempShow = false;
      }

      if (
        filterType !== "power" &&
        !matchesRange(+card.dataset.power, activeFilters.power || [])
      ) {
        tempShow = false;
      }

      if (filterType !== "price") {
        const price = parseInt(card.dataset.productPrice);
        if (
          activeFilters.priceMin !== null &&
          activeFilters.priceMax !== null
        ) {
          if (
            price < activeFilters.priceMin ||
            price > activeFilters.priceMax
          ) {
            tempShow = false;
          }
        }
      }

      if (tempShow) {
        if (isRange) {
          const value = +card.dataset[filterType];
          if (value >= rangeMin && value <= rangeMax) {
            count++;
          }
        } else if (filterType === "price") {
          const price = parseInt(card.dataset.productPrice);
          if (price >= rangeMin && price <= rangeMax) {
            count++;
          }
        } else if (filterType === "style") {
          const productStyles =
            card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
            [];
          if (productStyles.includes(filterValue)) {
            count++;
          }
        } else {
          if (card.dataset[filterType] === filterValue) {
            count++;
          }
        }
      }
    });

    return count;
  }

  function updateFilterCounts() {
    document
      .querySelectorAll('input[data-filter="brand"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("brand", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="producttype"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("producttype", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="style"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("style", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="frametype"]')
      .forEach((checkbox) => {
        const value = checkbox.value;
        const count = countProductsForFilter("frametype", value);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="range"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("range", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="speed"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("speed", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="capacity"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("capacity", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="weight"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("weight", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document
      .querySelectorAll('input[data-filter="power"]')
      .forEach((checkbox) => {
        const min = parseInt(checkbox.dataset.min);
        const max = parseInt(checkbox.dataset.max);
        const count = countProductsForFilter("power", null, true, min, max);
        const label = checkbox.nextElementSibling;
        const countSpan =
          label.querySelector(".filter-count") ||
          document.createElement("span");
        countSpan.className = "filter-count";
        countSpan.textContent = ` (${count})`;
        if (!label.querySelector(".filter-count")) {
          label.appendChild(countSpan);
        }
        checkbox.disabled = count === 0;
        checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
      });

    document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
      const min = parseInt(checkbox.dataset.min);
      const max = parseInt(checkbox.dataset.max);
      const count = countProductsForFilter("price", null, false, min, max);
      const label = checkbox.nextElementSibling;
      const countSpan =
        label.querySelector(".filter-count") || document.createElement("span");
      countSpan.className = "filter-count";
      countSpan.textContent = ` (${count})`;
      if (!label.querySelector(".filter-count")) {
        label.appendChild(countSpan);
      }
      checkbox.disabled = count === 0;
      checkbox.parentElement.style.opacity = count === 0 ? "0.5" : "1";
    });
  }

  function initializeFilters() {
    const urlParams = new URLSearchParams(window.location.search);

    document
      .querySelectorAll('input[type="checkbox"][data-filter]')
      .forEach((checkbox) => {
        const filterType = checkbox.dataset.filter;
        const value = checkbox.value.toLowerCase();

        const param = urlParams.get(`filter_${filterType}`);
        if (param) {
          const valuesFromUrl = param
            .split(",")
            .map((v) => v.trim().toLowerCase());
          if (valuesFromUrl.includes(value)) {
            checkbox.checked = true;

            if (checkbox.dataset.min) {
              activeFilters[filterType] = activeFilters[filterType] || [];
              activeFilters[filterType].push({
                min: parseInt(checkbox.dataset.min),
                max: parseInt(checkbox.dataset.max),
              });
            } else {
              const filterKey = filterType + "s";
              activeFilters[filterKey] = activeFilters[filterKey] || [];
              if (!activeFilters[filterKey].includes(value)) {
                activeFilters[filterKey].push(value);
              }
            }
          }
        }
      });

    const min = urlParams.get("price_min");
    const max = urlParams.get("price_max");
    if (min) activeFilters.priceMin = parseInt(min);
    if (max) activeFilters.priceMax = parseInt(max);

    applyClientSideFilters();
    updateActiveFilterDisplay();
    updateFilterCounts();
    updateBadgeVisibility();

    // Baseline snapshot so an early mobile Cancel has something to revert to.
    filtersSnapshot = snapshotFilters();
  }

  function updateURL() {
    const params = new URLSearchParams();

    Object.entries(activeFilters).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        if (
          values[0] &&
          typeof values[0] === "object" &&
          values[0].min !== undefined
        ) {
          return;
        }

        const filterType = key.endsWith("s") ? key.slice(0, -1) : key;
        params.set(`filter_${filterType}`, values.join(","));
      }
    });

    if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
      params.set("price_min", activeFilters.priceMin);
      params.set("price_max", activeFilters.priceMax);
    }

    const newURL = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;

    window.history.pushState({}, "", newURL);
  }

  // Runs the full "commit" pipeline: filter the grid, refresh tags/counts/
  // badges, and sync the URL. On mobile this only fires on Apply; on
  // desktop it fires immediately on every change, as before.
  function commitFilters() {
    applyClientSideFilters();
    updateActiveFilterDisplay();
    updateFilterCounts();
    updateURL();
    updateBadgeVisibility();
  }

  document
    .querySelectorAll('input[type="checkbox"][data-filter]')
    .forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const key = this.dataset.filter;

        if (this.dataset.min) {
          activeFilters[key] = activeFilters[key] || [];
          if (this.checked) {
            activeFilters[key].push({
              min: parseInt(this.dataset.min),
              max: parseInt(this.dataset.max),
            });
          } else {
            activeFilters[key] = activeFilters[key].filter(
              (r) => r.min != this.dataset.min
            );
          }
        } else {
          const filterKey = key + "s";
          const value = this.value;

          if (!activeFilters[filterKey]) {
            activeFilters[filterKey] = [];
          }

          if (this.checked) {
            if (!activeFilters[filterKey].includes(value)) {
              activeFilters[filterKey].push(value);
            }
          } else {
            activeFilters[filterKey] = activeFilters[filterKey].filter(
              (v) => v !== value
            );
          }
        }

        if (isMobile()) {
          // Stage the change only: refresh counts/tags for feedback inside
          // the sidebar, but leave the product grid/URL untouched until
          // the user taps Apply.
          updateActiveFilterDisplay();
          updateFilterCounts();
        } else {
          commitFilters();
        }
      });
    });

  document.querySelectorAll(".price-range-filter").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const min = parseInt(this.dataset.min);
      const max = parseInt(this.dataset.max);
      const label = this.nextElementSibling.cloneNode(true);
      label.querySelector(".filter-count")?.remove();
      const labelText = label.textContent.trim();

      if (this.checked) {
        document.querySelectorAll(".price-range-filter").forEach((cb) => {
          if (cb !== this) cb.checked = false;
        });

        activeFilters.priceMin = min;
        activeFilters.priceMax = max;
        activeFilters.priceRangeLabel = labelText;
      } else {
        activeFilters.priceMin = null;
        activeFilters.priceMax = null;
        activeFilters.priceRangeLabel = null;
      }

      if (isMobile()) {
        updateActiveFilterDisplay();
        updateFilterCounts();
      } else {
        commitFilters();
      }
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      sortVisibleProducts(this.value);
    });
  }

  function sortVisibleProducts(sortBy) {
    const visibleProducts = productCards.filter(
      (card) => card.style.display !== "none"
    );

    let sorted;

    switch (sortBy) {
      case "price-ascending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice)
        );
        break;

      case "price-descending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice)
        );
        break;

      case "title-ascending":
        sorted = visibleProducts.sort((a, b) =>
          a.dataset.productTitle.localeCompare(b.dataset.productTitle)
        );
        break;

      case "title-descending":
        sorted = visibleProducts.sort((a, b) =>
          b.dataset.productTitle.localeCompare(a.dataset.productTitle)
        );
        break;

      case "created-descending":
        sorted = visibleProducts.sort(
          (a, b) =>
            parseInt(b.dataset.productCreated) -
            parseInt(a.dataset.productCreated)
        );
        break;

      default:
        return;
    }

    sorted.forEach((card) => productsGrid.appendChild(card));
  }

  function applyClientSideFilters() {
    let visibleCount = 0;
    const productsPerPage = 200;

    productCards.forEach((card) => {
      let show = true;

      if (
        activeFilters.colors.length &&
        !activeFilters.colors.some((c) =>
          card.dataset.productColors?.split(",").includes(c)
        )
      )
        show = false;

      if (
        activeFilters.sizes.length &&
        !activeFilters.sizes.some((s) =>
          card.dataset.productSizes?.split(",").includes(s)
        )
      )
        show = false;

      if (
        activeFilters.producttypes?.length &&
        !activeFilters.producttypes.includes(card.dataset.producttype)
      )
        show = false;

      if (
        activeFilters.vendors.length &&
        !activeFilters.vendors.includes(card.dataset.productVendor)
      )
        show = false;

      if (
        activeFilters.brands?.length &&
        !activeFilters.brands.includes(card.dataset.brand)
      )
        show = false;

      if (activeFilters.styles?.length) {
        const productStyles =
          card.dataset.style?.split(",").map((s) => s.trim().toLowerCase()) ||
          [];
        if (!activeFilters.styles.some((s) => productStyles.includes(s)))
          show = false;
      }

      if (
        activeFilters.frametypes?.length &&
        !activeFilters.frametypes.includes(card.dataset.frametype)
      )
        show = false;

      if (!matchesRange(+card.dataset.range, activeFilters.range || []))
        show = false;

      if (!matchesRange(+card.dataset.speed, activeFilters.speed || []))
        show = false;

      if (!matchesRange(+card.dataset.capacity, activeFilters.capacity || []))
        show = false;

      if (!matchesRange(+card.dataset.weight, activeFilters.weight || []))
        show = false;

      if (!matchesRange(+card.dataset.power, activeFilters.power || []))
        show = false;

      const price = parseInt(card.dataset.productPrice);
      if (activeFilters.priceMin !== null && activeFilters.priceMax !== null) {
        if (price < activeFilters.priceMin || price > activeFilters.priceMax) {
          show = false;
        }
      }

      card.style.display = show ? "" : "none";
      if (show) visibleCount++;
    });

    if (productCountEl) {
      productCountEl.textContent = visibleCount;
      productCountLabel.textContent =
        visibleCount === 1 ? "product" : "products";
    }

    if (paginationEl) {
      paginationEl.style.display =
        visibleCount <= productsPerPage ? "none" : "";
    }
  }

  function updateActiveFilterDisplay() {
    const list = activeFiltersContainer.querySelector(".active-filters-list");
    list.innerHTML = "";

    if (activeFilters.priceRangeLabel) {
      const tag = document.createElement("span");
      tag.className = "filter-tag";
      tag.innerHTML = `${activeFilters.priceRangeLabel} <button data-filter-type="price">×</button>`;
      list.appendChild(tag);
    }

    Object.entries(activeFilters).forEach(([key, values]) => {
      if (!Array.isArray(values)) return;

      values.forEach((val) => {
        const tag = document.createElement("span");
        tag.className = "filter-tag";

        if (typeof val === "object" && val.min !== undefined) {
          tag.innerHTML = `${key}: ${val.min}-${val.max} <button data-k="${key}" data-min="${val.min}">×</button>`;
        } else {
          tag.innerHTML = `${val} <button data-k="${key}" data-v="${val}">×</button>`;
        }

        list.appendChild(tag);
      });
    });

    list.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.dataset.filterType === "price") {
          activeFilters.priceMin = null;
          activeFilters.priceMax = null;
          activeFilters.priceRangeLabel = null;
          document.querySelectorAll(".price-range-filter").forEach((cb) => {
            cb.checked = false;
          });
        } else if (btn.dataset.min) {
          const key = btn.dataset.k;
          const min = btn.dataset.min;
          activeFilters[key] = activeFilters[key].filter((r) => r.min != min);

          const checkbox = document.querySelector(
            `input[data-filter="${key}"][data-min="${min}"]`
          );
          if (checkbox) checkbox.checked = false;
        } else {
          const key = btn.dataset.k;
          const val = btn.dataset.v;
          activeFilters[key] = activeFilters[key].filter((v) => v !== val);

          const checkbox = document.querySelector(`input[value="${val}"]`);
          if (checkbox) checkbox.checked = false;
        }

        // Removing a tag is a direct commit on both mobile and desktop —
        // there's no ambiguity about intent here, so no need to stage it.
        commitFilters();
      });
    });

    activeFiltersContainer.style.display = list.children.length
      ? "block"
      : "none";
  }

  const filterOverlay = document.createElement("div");
  filterOverlay.className = "filter-overlay";
  filterOverlay.id = "FilterOverlay";
  document.body.appendChild(filterOverlay);

  const mobileCloseBtn = document.getElementById("MobileFilterClose");

  function openMobileSidebar() {
    // Snapshot whatever is currently APPLIED so Cancel has a clean state
    // to roll back to, even if the user leaves some boxes checked mid-way.
    filtersSnapshot = snapshotFilters();

    sidebar.classList.add("active");
    document.body.classList.add("filter-open");
    filterOverlay.classList.add("active");
  }

  function closeMobileSidebar() {
    sidebar.classList.remove("active");
    document.body.classList.remove("filter-open");
    filterOverlay.classList.remove("active");
  }

  if (mobileToggle && sidebar) {
    mobileToggle.addEventListener("click", openMobileSidebar);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener("click", closeMobileSidebar);
  }

  // "Apply" — commit whatever is currently checked, close, and scroll back
  // to the top so the person lands on the newly filtered results instead
  // of wherever they'd scrolled to while browsing the filter sidebar.
  if (mobileApplyBtn) {
    mobileApplyBtn.addEventListener("click", () => {
      commitFilters();
      filtersSnapshot = snapshotFilters();
      closeMobileSidebar();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // Tap-outside / Esc: a safe, non-destructive dismiss — reverts to
  // whatever was last APPLIED (doesn't touch the grid/URL) and closes.
  // Kept separate from the Cancel button below so an accidental tap
  // outside the sidebar can't wipe someone's filters.
  function revertToSnapshotAndClose() {
    activeFilters = filtersSnapshot
      ? JSON.parse(JSON.stringify(filtersSnapshot))
      : activeFilters;

    syncCheckboxesToFilters(activeFilters);
    updateActiveFilterDisplay();
    updateFilterCounts();
    closeMobileSidebar();
  }

  // "Cancel" — now behaves the same as "Clear All": wipes every filter,
  // applies the cleared state to the grid/URL, closes the sidebar, and
  // scrolls back to the top.
  if (mobileCancelBtn) {
    mobileCancelBtn.addEventListener("click", () => {
      Object.keys(activeFilters).forEach((k) => {
        if (Array.isArray(activeFilters[k])) {
          activeFilters[k] = [];
        } else {
          activeFilters[k] = null;
        }
      });

      document
        .querySelectorAll('input[type="checkbox"]')
        .forEach((c) => (c.checked = false));

      commitFilters();
      filtersSnapshot = snapshotFilters();
      closeMobileSidebar();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  filterOverlay.addEventListener("click", () => {
    revertToSnapshotAndClose();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sidebar.classList.contains("active")) {
      revertToSnapshotAndClose();
    }
  });

  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener("click", () => {
      Object.keys(activeFilters).forEach((k) => {
        if (Array.isArray(activeFilters[k])) {
          activeFilters[k] = [];
        } else {
          activeFilters[k] = null;
        }
      });

      document
        .querySelectorAll('input[type="checkbox"]')
        .forEach((c) => (c.checked = false));

      // "Clear all" is an explicit, unambiguous commit — apply immediately
      // even on mobile, and refresh the snapshot to match.
      commitFilters();
      filtersSnapshot = snapshotFilters();
    });
  }

  initializeFilters();
});